export default "__VITE_ASSET__TP$JH7rg__"